var map = {
	"./el_fruits_red_cart.png": 99175,
	"./en_fruits_red_cart.png": 98669,
	"./it_fruits_red_cart.png": 7875,
	"./ro_fruits_red_cart.png": 8277,
	"./uk_fruits_red_cart.png": 15424
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22989;